var render, staticRenderFns
import script from "./customer_record_flow.vue?vue&type=script&lang=js"
export * from "./customer_record_flow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0240739f')) {
      api.createRecord('0240739f', component.options)
    } else {
      api.reload('0240739f', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/execute/customer_record_flow/customer_record_flow.vue"
export default component.exports